import { render, staticRenderFns } from "./NewEventDocument.vue?vue&type=template&id=0b80e2b2&"
import script from "./NewEventDocument.vue?vue&type=script&lang=js&"
export * from "./NewEventDocument.vue?vue&type=script&lang=js&"
import style0 from "./NewEventDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports